export const SN_ORDER = 'order'
export const ORDER_PRCHS_ORDRS_UPDATED = SN_ORDER + '/PRCHS_ORDRS_UPDATED'
export const ORDER_CURRENT_UPDATED = SN_ORDER + '/CURRENT_UPDATED'
export const ORDER_CURRENT_PRODUCT_ADDED = SN_ORDER + '/CURRENT_PRODUCT_ADDED'